import {
  CompanyType,
  mapCompanyType,
  useCreateCompany as useCreateCompanyApi,
} from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { CreateCompanyType } from 'src/api/generated/touring/types';

const TRANS_KEY = 'NOTIFICATIONS.ADD_COMPANY';

type UseSubmitNewCompanyReturnType = {
  submitNewCompany: (data: CreateCompanyType) => Promise<CompanyType>;
};

export const useCreateCompany = (): UseSubmitNewCompanyReturnType => {
  const { mutateAsync: createCompany } = useCreateCompanyApi();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitNewCompany = async (
    data: CreateCompanyType
  ): Promise<CompanyType> => {
    const response = await createCompany({ data }, { onSuccess, onError });
    return mapCompanyType(response.data);
  };

  return { submitNewCompany };
};
